import { useQuery } from 'react-query';
import { getCustomerId } from './getCustomerId';

export function useCustomerIdQuery() {
  return useQuery(['global_customer_id'], () => getCustomerId());
}
